<template>
  <div :class="containerClass">
    <h4 v-if="hasTitle" :class="titleClass">
      <i :class="icon" class="mx-2"></i>
      {{ title }}
      <slot name="headerContent"> </slot>
    </h4>
    <div v-if="hasSubTitle" :class="subTitleClass">
      <slot name="subTitle"> </slot>
    </div>
    <hr :class="lineStyle" />
  </div>
</template>
<script>
export default {
  props: {
    hasSubTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    subTitleClass: {
      type: String,
      required: false,
      default: '',
    },
    titleClass: {
      type: String,
      required: false,
      default: 'text-secondary',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    lineThem: {
      type: String,
      required: false,
      default: 'right',
    },
    hasTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    lineStyle() {
      return this.lineThem == 'right'
        ? 'hr-right'
        : this.lineThem == 'center'
        ? 'hr-center'
        : this.lineThem == 'left'
        ? 'hr-left'
        : '';
    },
  },
};
</script>

<style scoped>
hr {
  /* display: block; */
  border: none;
  color: white;
  height: 1px;
  background: black;
  /*background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 350, from(#000), to(#fff));*/
}

.hr-center {
  background: -webkit-gradient(
    radial,
    50% 50%,
    0,
    50% 50%,
    650,
    from(#000),
    to(#fff)
  );
}

.hr-right {
  background: -webkit-gradient(
    radial,
    100% 144%,
    0,
    60% 0%,
    700,
    from(#000),
    to(#fff)
  );
}

.hr-left {
  background: -webkit-gradient(
    radial,
    50% 50%,
    0,
    0% 50%,
    900,
    from(#000),
    to(#fff)
  );
}

@media only screen and (max-width: 991px) {
  /* h4 {
    font-size: 1rem !important;
  } */
  svg {
    font-size: 1.5rem !important;
  }
}
/* svg {
  font-size: 1.5rem !important;
}
h4 {
  font-size: 1rem !important;
}
hr {
  margin-top: 1rem !important;
}
@media only screen and (max-width: 1154px) {
  svg {
    margin-bottom: 5px;
    font-size: 1.5rem !important;
  }
  h4 {
    font-size: 1rem !important;
  }
  hr {
    margin-top: 1.5rem !important;
  }
} */
</style>
